export const LOGIN = {
  ACCOUNTS_NOT_FOUND: 'ACCOUNTS_NOT_FOUND', // id 에러
  FAIL_TO_LOGIN: 'FAIL_TO_LOGIN', // pw 에러
  LOCKED_ACCOUNT: 'LOCKED_ACCOUNT', // 계정 잠김
  IS_NOT_LOGIN_PAGE: 'IS_NOT_LOGIN_PAGE', // isAdmin키 없을 때
  UNAUTHORIZED_ACCESS_IP: 'UNAUTHORIZED_ACCESS_IP', // 접속 허용하지 않은 ip
  INVALID_OTP_REQUEST: 'INVALID_OTP_REQUEST', // 유효하지 않은 요청
  NEED_OTP_AUTHENTICATION: 'NEED_OTP_AUTHENTICATION', // 2차 인증 필요
  NEED_OTP_EMAIL_CONFIRM: 'NEED_OTP_EMAIL_CONFIRM', // 이메일 확인 필요
  NEED_OTP_AUTHY_RESISTER: 'NEED_OTP_AUTHY_RESISTER', // authy 등록 필요
  DUPLICATION_ACCESS_EXCEPTION: 'DUPLICATION_ACCESS_EXCEPTION', // 중복 로그인 불가 (이미 로그인 되어잇는 계정에 강제 로그인 시)
  DUPLICATION_LOGIN_EXCEPTION: 'DUPLICATION_LOGIN_EXCEPTION', // 중복 로그인 불가 (강제 로그인 당하는 경우)
  TOKEN_EXPIRED: 'TOKEN_EXPIRED', // 토큰 만료
  ACCOUNTS_PASSWORD_EXPIRED: 'ACCOUNTS_PASSWORD_EXPIRED', // 패스워드 변경 90일 만료
  ACCOUNT_PASSWORD_IS_SAME: 'ACCOUNT_PASSWORD_IS_SAME', // 90일 비밀번호 변경시 이전과 동일한 비밀번호 입력시
  ACCOUNT_PASSWORD_MODIFY_AUTH_TOKEN_FAIL: 'ACCOUNT_PASSWORD_MODIFY_AUTH_TOKEN_FAIL', // 90일 비밀번호 변경시 입력시간 초과 또는 유효하지 않은 요청
  CERTIFY_EMAIL_EXPIRE: 'CERTIFY_EMAIL_EXPIRE' // 90일 비밀번호 변경시 메일 인증 기간 만료
};



// WEBPACK FOOTER //
// ./src/constants/errorCode.js